import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  discount_price_text: {
    marginRight: 5,
  },
});
